import type { BrandCode } from "brandRegionConfig";
import BrandMap from "resources/BrandMap";
import { getBrandTwoLetterCodeFromHost } from "./getBrandTwoLetterCodeFromHost";

export function getBrandCodeFromHost(host: string): BrandCode | undefined {
  const brandTwoLetterCode = getBrandTwoLetterCodeFromHost(host);
  if (!brandTwoLetterCode) {
    return undefined;
  }
  return BrandMap.get(brandTwoLetterCode)?.brandCode;
}
